import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper/modules';
import { useNavigate } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import axios from "axios";
import { ReactSession } from "react-client-session";
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import feather from 'feather-icons';
import Swal from 'sweetalert2';
import ProductImageZoom from '../components/ProductImageZoom';


ReactSession.setStoreType("localStorage");

const SingleProduct = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [relatedProduct, setrelatedProduct] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedColor, setSelectedColor] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const productDetailColRef = useRef(null);
  const [deletedprice, setDeletedPrice] = useState(0);
  const location = useLocation();
 
  
  //console.log(selectedSize);

  useEffect(() => {

    feather.replace();
  }, []);



  useEffect(() => {

    if (location.state?.isSearchResult) {
      setProduct(location.state.products);
      setLoading(false);
      return;
    }




    const fetchProduct = async () => {
      try {
        const response = await axios.post("https://api.welbeing.in/product/single-product/", { p_id: id });

        //  console.log(response.data);
        if (response.data.status === "success") {
          setProduct(response.data.data);
          const basePrice = parseFloat(response.data.data.item_price);
          setDeletedPrice(basePrice + 10)


          const moq = parseInt(response.data.data.item_moq) || 50;
          setQuantity(moq);
          // setCurrentPrice(response.data.data.item_price);
          setCurrentPrice(basePrice);


          if (response.data.data.colors?.length > 0) {
            setSelectedColor(response.data.data.colors[0].id);
          }
          if (response.data.data.designs?.length > 0) {
            setSelectedDesign(response.data.data.designs[0].id);
          }
          if (response.data.data.size?.length > 0) {
            // Set the initial selected size in react-select format
            const initialSize = {
              value: response.data.data.size[0].id,
              label: `${response.data.data.size[0].size} - ₹${response.data.data.size[0].amount}`,
              rawData: response.data.data.size[0]
            };
            setSelectedSize(initialSize);
            setCurrentPrice(response.data.data.size[0].amount);
          } else {
            setCurrentPrice(response.data.data.item_price);
          }


        } else {
          setError("Product not found");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);




  const handleSizeChange = (selectedOption) => {
    //console.log(selectedOption);
    setSelectedSize(selectedOption);

    // Update the current price based on selection
    if (selectedOption) {
      const selected = product.size?.find(s => s.id === selectedOption.value);
      setCurrentPrice(selected?.amount || product.item_price);
    } else {
      setCurrentPrice(product.item_price);
    }
  };





  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#911077',
      borderColor: state.isFocused ? '#a31a89' : '#911077',
      borderRadius: '10px',
      minHeight: '40px',
      boxShadow: state.isFocused ? '0 0 0 1px #a31a89' : 'none',
      '&:hover': {
        borderColor: '#a31a89'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#911077' : 'white',
      color: state.isSelected ? 'white' : '#333',
      '&:hover': {
        backgroundColor: '#a31a89',
        color: 'white'
      }
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'white',
      '&:hover': {
        color: 'white'
      }
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      overflow: 'hidden'
    })
  };


  useEffect(() => {
    const fetchrelatedProduct = async () => {
      try {
        const response = await axios.get("https://api.welbeing.in/product/related-products/");
        //console.log(response.data);
        if (response.data.status === "success") {
          setrelatedProduct(response.data.data);
          //console.log(response.data.data);
        } else {
          setError("Product not found");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchrelatedProduct();
  }, []);

  useEffect(() => {
    setActiveImageIndex(0);
  }, [id]);

  useEffect(() => {
    if (thumbsSwiper && thumbsSwiper.activeIndex !== activeImageIndex) {
      thumbsSwiper.slideTo(activeImageIndex);
    }
  }, [thumbsSwiper, activeImageIndex]);

  //  const handleQuantityChange = (type) => {
  //     const moq = parseInt(product?.item_moq) || 50;
  //     setQuantity((prev) => {
  //       if (type === "plus") {
  //          if (product.preOrder === 'yes') {
  //              return prev + 1;
  //         }else{
  //           const existingCartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
  //   const existingItem = existingCartItems.find((item) => item.id === id);
  // const existingQuantity = existingItem ? existingItem.quantity : 0;
  //   //console.log(existingCartItems);

  //            if (prev + 1 + existingQuantity > product.stock) {
  //             const available = product.stock - existingQuantity;
  //            alert(`Only ${available} more available (${existingQuantity} already in cart)`);
  //           return prev;
  //         }else{
  //          return  prev + 1 ;
  //         }
  //         }
  //       } else if (type === "minus" && prev > moq) {
  //         return prev - 1;
  //       }
  //       return prev;
  //     });
  //   };


  const handleQuantityChange = (type) => {
    const moq = parseInt(product?.item_moq); // Minimum order quantity
    // Get existing cart quantity (0 if not in cart)
    const existingCartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
    const existingItem = existingCartItems.find(item => item.id === id);
    const existingQuantity = existingItem?.quantity || moq;

    setQuantity(prev => {

      if (type === "plus") {
        // For pre-order items - no stock limit
        if (product.preOrder === 'yes') return prev + 1;

        // For regular items - check stock
        const requestedTotal = quantity + 1;
        //console.log(requestedTotal, quantity);

        if (requestedTotal <= product.stock) {
          return prev + 1;

          // Allow increase
        } else {
          const available = product.stock - existingQuantity;
          Swal.fire({
            icon: 'warning',
            title: 'Limited Stock',
            text: `Only ${available} more available (${existingQuantity} in cart)`,
            confirmButtonColor: '#f39c12',
            confirmButtonText: 'OK'
          });

          return prev;
        }
      }
      else if (type === "minus") {
        return prev > moq ? prev - 1 : prev;
      }
      return prev;
    });
  };










  // const handleInputChange = (e) => {
  //   const inputValue = e.target.value;

  //   // Allow empty value (for deletion) or numeric input
  //   if (inputValue === "" || /^[0-9]*$/.test(inputValue)) {
  //     setQuantity(inputValue === "" ? "" : parseInt(inputValue));
  //   }
  // };

  // const handleBlur = (e) => {
  //   const moq = parseInt(product?.item_moq) || 50;
  //   const value = e.target.value === "" ? moq : parseInt(e.target.value) || moq;
  //   setQuantity(Math.max(value, moq));
  // };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Allow empty or numeric values only
    if (inputValue === "" || /^[0-9]*$/.test(inputValue)) {
      setQuantity(inputValue === "" ? "" : parseInt(inputValue));
    }
  };


  const handleBlur = (e) => {
    const moq = parseInt(product?.item_moq) || 50;
    let value = e.target.value === "" ? moq : parseInt(e.target.value) || moq;

    const existingCartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
    const existingQuantity = existingCartItems.find(item => item.id === id)?.quantity || 0;

    if (product.preOrder !== 'yes') {
      const maxAllowed = product.stock - existingQuantity;
      const available = Math.max(0, maxAllowed);

      if (available <= 0) {
        Swal.fire({
          // icon: 'error',
          title: 'Out of Stock',
          text: `(${existingQuantity} already in cart)`,
          confirmButtonColor: '#d33',
          confirmButtonText: 'OK',
          backdrop: true,
        });

        value = moq;
      }
      else if (value > available) {
        Swal.fire({
          icon: 'warning',
          title: 'Only Limited Items Left',
          text: `Only ${available} more available (${existingQuantity} in cart)`,
          confirmButtonColor: '#e67e22',
          confirmButtonText: 'OK'
        });
      }
      else if (value === available) {
        //console.log(`Maximum quantity (${available}) selected`);
        //console.log(value);
        setQuantity(existingQuantity + available);
      }
      else if (value < moq) {
        alert(`Minimum order quantity is ${moq}`);
        value = moq;
      }


      value = Math.max(value, moq);
    } else {
      const moq = parseInt(product?.item_moq) || 50;
      setQuantity(Math.max(value, moq));
    }

    // Set the final validated quantity

  };




  // const addToCart = (action = "addtocart") => {
  //   try {
  //     //console.log("Product ID:", id);

  //     // Get the existing cart items from session storage
  //     const existingCartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];

  //     // Check if the product is already in the cart
  //     const existingItemIndex = existingCartItems.findIndex(
  //       (item) => item.id === id
  //     );

  //     if (existingItemIndex !== -1) {
  //       const updatedQuantity = quantity;


  //       console.log(updatedQuantity);
  //       // console.log(updatedQuantity);
  //       // Check if adding the product will exceed the available stock
  //       if (product.stock > updatedQuantity) {
  //         // Check if adding the product will exceed the available stock

  //           const moqNumber = parseInt(product.item_moq); // or product.moq, whichever is correct
  //           const currentQuantity = existingCartItems[existingItemIndex].quantity;

  //           if (currentQuantity >= moqNumber && updatedQuantity === moqNumber) {

  //             const qty = currentQuantity + 1
  //             if (qty <= product.stock) {
  //               existingCartItems[existingItemIndex].quantity = qty;
  //             } else {
  //               alert(`Insufficient stock for ${product.item_name}`);
  //             }
  //             // Add 1 to quantity if MOQ condition is met
  //             // existingCartItems[existingItemIndex].quantity = currentQuantity;
  //             // alert(currentQuantity + 1);
  //           } else {
  //             // Otherwise just update to the intended quantity
  //             existingCartItems[existingItemIndex].quantity = updatedQuantity;
  //             // alert(updatedQuantity);
  //           }



  //       } else {
  //         // If there's insufficient stock, show an alert
  //         existingCartItems[existingItemIndex].quantity = updatedQuantity;
  //         alert(`${product.item_name} quantity updated in carts!`);
  //         return; // Stop further execution
  //       }

  //       // alert(`${product.item_name} already in cart!`);
  //     } else {
  //       // Calculate GST amount
  //       const gstAmount = (product.gst / 100) * currentPrice;

  //       // Calculate price with GST included
  //       const priceWithGst = Number(currentPrice) + Number(gstAmount);



  //       const newItem = {
  //         id: id,
  //         code: product.item_code,
  //         product: product.item_name,
  //         price: currentPrice,
  //         quantity: quantity,
  //         image: product.img1,
  //         color: selectedColor,
  //         design: selectedDesign,
  //         size: selectedSize?.rawData?.size || '',
  //         weight: product.item_weight,
  //         totalwithGst: (priceWithGst * quantity).toFixed(2),
  //         totalwithoutGst: (currentPrice * quantity).toFixed(2),
  //         prices: priceWithGst,
  //         preOrder: product.preOrder,
  //         stock: product.stock,
  //         orderType: product.preOrder === 'yes' && product.stock < quantity ? 'preorder' : 'order',
  //       };
  //       existingCartItems.push(newItem);

  //     }

  //     // Update session storage
  //     sessionStorage.setItem("cartItems", JSON.stringify(existingCartItems));
  //     window.dispatchEvent(new Event('cartUpdated'));
  //     window.dispatchEvent(new Event('storage'));

  //     // Different behavior based on action
  //     if (action === "buynow") {
  //       // Redirect to checkout immediately
  //       window.location.href = "/checkout";
  //     }
  //     else if (action === "outofstock") {
  //       // Redirect to checkout immediately
  //       alert(`${product.item_name} out of stock!`);
  //     } else {
  //       if (existingItemIndex !== -1) {
  //         alert(`${product.item_name} quantity updated in cart!`);
  //       } else {
  //         alert(`${product.item_name} added to cart!`);
  //       }

  //     }



  //   } catch (error) {
  //     console.error("Error handling cart:", error);
  //     alert("Failed to add item to cart.");
  //   }
  // };


  const addToCart = (action = "addtocart") => {


    if (action === "buynow") {
      sessionStorage.removeItem('cartItems');
      window.location.href = "/checkout";
    }

    if (action === "outofstock") {
      Swal.fire({
        title: 'Out of Stock',
        text: `(${product.item_name} out of stock!)`,
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK',
        backdrop: true,
      });
    } else {
      try {
        const existingCartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
        const existingItemIndex = existingCartItems.findIndex(item => item.id === id);



        if (existingItemIndex !== -1) {
          const updatedQuantity = quantity;


          const moqNumber = parseInt(product.item_moq);
          const currentQuantity = existingCartItems[existingItemIndex].quantity;
          const qty = currentQuantity + 1;

          if (currentQuantity >= moqNumber && updatedQuantity === moqNumber) {

            console.log(quantity, currentQuantity);
            //  existingCartItems[existingItemIndex].quantity = qty <= product.stock ? qty : currentQuantity;

            if (product.preOrder === "yes") {
              existingCartItems[existingItemIndex].quantity = qty;

            }



            if (product.preOrder === "no") {
              if (qty <= product.stock) {
                existingCartItems[existingItemIndex].quantity = qty;
              } else {
                existingCartItems[existingItemIndex].quantity = currentQuantity;
                // alert(`${product.item_name} is out of stocks!`);

              }
            }

          } else {
            if (product.preOrder === "yes") {
               const qtys = currentQuantity + quantity;
                if(quantity > currentQuantity){
               existingCartItems[existingItemIndex].quantity = qtys;
                }else{
                  existingCartItems[existingItemIndex].quantity = updatedQuantity;
                }
             
                //  alert("no");
            }



            if (product.preOrder === "no") {
            
              console.log(quantity, currentQuantity);
              if (qty <= product.stock) {
                 const qtys = currentQuantity + quantity;
                if(quantity > currentQuantity){
               existingCartItems[existingItemIndex].quantity = qtys;
                }else{
                  existingCartItems[existingItemIndex].quantity = updatedQuantity;
                }
              } else {
                existingCartItems[existingItemIndex].quantity = currentQuantity;
                // alert(`${product.item_name} is out of stocks!`);

              }
            }

          }
        } else {
          // if (quantity > product.stock) {
          //   Swal.fire({
          //     title: 'Out of Stock',
          //     html: `Insufficient stock for <b>${product.item_name}</b>`,
          //     confirmButtonColor: '#d33',
          //     confirmButtonText: 'OK'
          //   });

          //   return;
          // }

          const gstAmount = (product.gst / 100) * currentPrice;
          const priceWithGst = Number(currentPrice) + Number(gstAmount);

          const newItem = ({
            id: id,
            code: product.item_code,
            product: product.item_name,
            price: currentPrice,
            quantity: quantity,
            image: product.img1,
            color: selectedColor,
            design: selectedDesign,
            size: selectedSize?.rawData?.size || '',
            weight: product.item_weight,
            totalwithGst: (priceWithGst * quantity).toFixed(2),
            totalwithoutGst: (currentPrice * quantity).toFixed(2),
            prices: priceWithGst,
            preOrder: product.preOrder,
            stock: product.stock,
            orderType: product.preOrder === 'yes' && product.stock < quantity ? 'preorder' : 'order',
          });
          existingCartItems.push(newItem);
        }

        sessionStorage.setItem("cartItems", JSON.stringify(existingCartItems));


        window.dispatchEvent(new Event('cartUpdated'));
        window.dispatchEvent(new Event('storage'));




        if (action === "addtocart") {
          const currentQuantity = existingCartItems[existingItemIndex].quantity;
          const qty = currentQuantity + 1;
          if (product.preOrder === "yes") {
            // alert(`${product.item_name} ${existingItemIndex !== -1 ? 'quantity updated in' : 'added to'} cart!`);
            Swal.fire({
              icon: 'success',
              title: 'Cart Updated',
              text: `${product.item_name} ${existingItemIndex !== -1 ? 'quantity updated in' : 'added to'} cart!`,
              confirmButtonColor: '#28a745',
              confirmButtonText: 'OK'
            });
            setQuantity(parseInt(product.item_moq));
          }



          if (product.preOrder === "no") {
            if (qty <= product.stock) {
              // alert(`${product.item_name} ${existingItemIndex !== -1 ? 'quantity updated in' : 'added to'} cart!`);
              Swal.fire({
                icon: 'success',
                title: 'Cart Updated',
                text: `${product.item_name} ${existingItemIndex !== -1 ? 'quantity updated in' : 'added to'} cart!`,
                confirmButtonColor: '#28a745',
                confirmButtonText: 'OK'
              });
              setQuantity(parseInt(product.item_moq));
            } else {

              // alert(`${product.item_name} is out of stocks!`);
              Swal.fire({
                icon: 'error',
                title: 'Out of Stock',
                text: `${product.item_name} is out of stocks!`,
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK'
              });
                setQuantity(parseInt(product.item_moq));
            }
          }

        }

        // alert(`${product.item_name} ${existingItemIndex !== -1 ? 'quantity updated in' : 'added to'} cart!`);



      } catch (error) {
        console.error("Error handling cart:", error);
        // alert("Failed to add item to cart.");
      }
    }
  };




  const addTowish = async () => {
    const cust_id = ReactSession.get("welbeinguserId");

    if (cust_id === "0") {
      navigate("/login");
      return;
    }

    const wishlistItems = JSON.parse(sessionStorage.getItem('wishlistItems')) || [];
    const existingwhislistItemIndex = wishlistItems.findIndex((item) => item.id === id);


    if (existingwhislistItemIndex !== -1) {
      alert(`${product.item_name} already in Wishlist!`);
    } else {
      const newItem = {
        id: id,
        name: product.item_name,
        price: currentPrice,
        image: product.img1
      };
      wishlistItems.push(newItem);
      sessionStorage.setItem("wishlistItems", JSON.stringify(wishlistItems));
      //console.log("Added to wishlist:", newItem);
      window.dispatchEvent(new Event('wishlistUpdated'));
      alert('Product added to wishlist successfully!');
      // navigate('/wishlist');
    }
  };



  if (loading) {
    return (
      <>
        <Header />
        <div className="container text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="container text-center py-5">
          <div className="alert alert-danger">Error: {error}</div>
        </div>
        <Footer />
      </>
    );
  }

  if (!product) {
    return (
      <>
        <Header />
        <div className="container text-center py-5">
          <div className="alert alert-warning">Product not found</div>
        </div>
        <Footer />
      </>
    );
  }

  const baseImageUrl = "https://api.welbeing.in/uploads/products/";
  const productImages = [product.img1, product.img2, product.img3, product.img4]
    .filter((img) => img)
    .map((img) => baseImageUrl + img);

  const createDescription = () => {
    return { __html: product.des };
  };
  const moqNumeric = parseInt(product.item_moq) || 50;

  return (
    <>
      <Header />
      <main className="main">
        <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{ minHeight: '10px' }}>
            <div className="container-lg">
              <div className="breadcrumb-box">
                {/* <div className="heading-box">
                  <h1>products</h1>
                </div> */}
                <ol className="breadcrumb">
                  <li>  <a href="/">Products</a></li>
                  <li>
                    <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                  </li>
                  <li className="current"><a href="">{product.item_name}</a></li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="product-page">
          <div className="container-lg">
            <div className="row g-3 g-xl-4 view-product">
              <div className="col-md-8">
                <div className="slider-box sticky off-50 position-sticky">
                  <div className="row g-2">
                    <div className="col-2">
                      <div className="thumbnail-box">
                        <Swiper onSwiper={setThumbsSwiper} direction="vertical" spaceBetween={10} slidesPerView={4} freeMode={true} modules={[FreeMode, Navigation]} className="thumbnail-img-box">
                          {productImages.map((image, index) => (
                            <SwiperSlide
                              key={index}
                              className={activeImageIndex === index ? "thumb-slide-active" : ""}
                              onClick={() => setActiveImageIndex(index)}
                            >
                              <img
                                className="border-lg"
                                src={image}
                                alt={`Thumbnail ${index + 1}`}
                                style={{ cursor: 'pointer', width: '100%', height: '100%' }}
                                onClick={() => setActiveImageIndex(index)}
                                onError={(e) => {
                                  e.target.src = "https://api.welbeing.in/uploads/products/no_img.jpg";
                                }}
                              />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    </div>

                    <div className="col-10 ratio_square">
                      <ProductImageZoom
                        images={productImages}
                        activeIndex={activeImageIndex}
                        flyoutAnchorRef={productDetailColRef}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4" ref={productDetailColRef}>
                <div className="product-detail-box">
                  <div className="product-option">
                    <h5 className="heading mb-4" style={{ color: "#95127b" }}>Item Code: <span>{product.item_code}</span></h5>
                    <h2>{product.item_name}</h2>
                    <div className="option price">
                      <span style={{fontSize: '30px', fontWeight: '700'}}>₹{parseInt(currentPrice).toFixed(2)}</span>
                      &nbsp; &nbsp; &nbsp;
                      <del style={{ color: '#911077' }}>₹{deletedprice.toFixed(2)}</del>
                      <span style={{ fontSize: '0.8em', marginLeft: '4px' }}>(Inc.Tax)</span>
                    </div>
                    <div className="option rating-option">
                      <h5 className="heading mt-2">MOQ: <span className="bg-theme-blue"></span></h5>
                      <span>{product.item_moq}</span>
                    </div>


                    <div className="option-side">
                      <div className="option">
                        <div className="title-box4">
                          <h4 className="heading">Quantity:<span className="bg-theme-blue"></span></h4>
                        </div>
                        <div className="plus-minus">
                          <button type="button" className="sub" onClick={() => handleQuantityChange("minus")} disabled={quantity <= moqNumeric} 
                            style={{ color: quantity <= moqNumeric ? '#ccc' : '#333' }}>
                            <i class="fa fa-minus"></i>
                          </button>
                          <input
                            type="number"
                            className="qty"
                            id="quantity"
                            name="quantity"
                            value={quantity}
                            min={moqNumeric}
                            style={{ width: "100px", color: "#333" }}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                          />
                          <button type="button" className="add" onClick={() => handleQuantityChange("plus")}>

                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>


                    {/* size Selection */}
                    {product.size?.length > 0 && (
                      <div className="option">
                        <h5 className="heading">Select Size:</h5>
                        <div className="mb-4" style={{ maxWidth: '200px' }}>
                          <Select
                            options={product.size?.map(size => ({
                              value: size.id,
                              label: `${size.size} - ₹${size.amount}`,
                              rawData: size
                            })) || []}
                            onChange={handleSizeChange}
                            value={selectedSize}
                            styles={customStyles}
                            isSearchable={false}
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>

                    )}

                    {/* Color Selection */}
                    {product.colors?.length > 0 && (
                      <div className="option">

                        <h5 className="heading">Select Color: <span class="bg-theme-blue" style={{ fontSize: '0.8em', marginLeft: '10px' }}>(Colors may differ from images shown and subject to availability. )</span></h5>

                        <div className="mb-4" style={{ display: "flex", flexWrap: "wrap", gap: "10px", }}>
                          {product.colors?.map((color) => (
                            <label key={color.id} className="custom-radio text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
                              <input type="radio" name="color" value={color.id} onChange={(e) => setSelectedColor(e.target.value)} required checked={selectedColor === color.id} style={{ display: "none" }} />
                              <div className="radio-box" style={{
                                backgroundColor: color.code,
                                width: "50px",
                                height: "50px",
                                borderRadius: '10px',
                                position: "relative",
                                cursor: "pointer",
                              }}
                              >
                                {selectedColor === color.id && (
                                  <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    color: "white",
                                    fontSize: "24px",
                                    fontWeight: "bold",
                                    textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                                  }}
                                  >
                                    ✓
                                  </div>
                                )}
                              </div>
                              <small style={{ color: "#333 !important", marginTop: "5px" }}>
                                {color.color}
                              </small>
                            </label>
                          ))}
                        </div>

                      </div>

                    )}

                    {/* Design Selection */}
                    {product.designs?.length > 0 && (
                      <div className="option">
                        <h5 className="heading">Select Design:</h5>
                        <div className="mb-4" style={{ display: "flex", gap: "15px" }}>
                          {product.designs?.map((design) => (
                            <label key={design.id} className="custom-radio text-center" style={{ cursor: "pointer", position: "relative" }}>
                              <input type="radio" name="design" value={design.id} onChange={(e) => setSelectedDesign(e.target.value)} required checked={selectedDesign === design.id} data-gtm-form-interact-field-id={design.id} style={{ display: "none" }} />
                              <div className="design-box" style={{
                                backgroundColor: "#fff",
                                border: selectedDesign === design.id ? "2px solid #911077" : "1px solid #ccc",
                                minWidth: "50px",
                                minHeight: "50px",
                                padding: "8px 12px",
                                borderRadius: '10px',
                                color: "#333",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "0.85rem",
                                fontWeight: selectedDesign === design.id ? "600" : "400",
                              }}>
                                {design.design}
                              </div>
                            </label>
                          ))}
                        </div>
                      </div>
                    )}

                    {product.preOrder === 'yes' && product.stock < quantity ? (<>
                      <button type="submit" class="w-100 btn-solid addtocart-btns mb-line justify-content-center mb-4 mt-4" name='addpos' onClick={(e) => { e.preventDefault(); addToCart("buynow"); }}>Pre-Order</button></>)
                      : product.preOrder === 'no' && product.stock < quantity ? (<> <button type="submit" class="w-100 btn-solid addtocart-btns mb-line justify-content-center mb-4 mt-4" name='addpos' onClick={(e) => { e.preventDefault(); addToCart("outofstock"); }}>Out Of Stock</button>
                      </>
                      ) : (<><button type="submit" class="w-100 btn-solid addtocart-btns mb-line justify-content-center mb-4 mt-4" name='addpos' onClick={(e) => { e.preventDefault(); addToCart("buynow"); }}>Buy Now</button>

                      </>)}

                    <div className="btn-group">
                      <button onClick={(e) => { e.preventDefault(); addToCart("addtocart"); }} type="submit" className="btn-outline btn-sm wishlist-btns w-50 justify-content-center addtocart" name="addpos" id="cartButton1" value="Add to Cart">Add to cart</button>
                      <button onClick={() => { addTowish(product.p_id) }} className="btn-outline btn-sm wishlist-btns w-50 justify-content-center addtowishlist" target="dummyframe">Add To Wishlist</button>
                    </div>

                    <div class="option mt-5 text-center" align="center">

                      <div style={{ background: '#fff', borderRadius: '30px', padding: '50px', textAlign: 'center' }}>
                        <h4 class="dark-color">
                          Need Help in Placing Order or Faster Delivery?
                        </h4>
                        <a class="btn-solid btn-sm info-btns mt-4" href="tel:+919047473959"><i class="fa fa-phone"></i>+91 90474 73959</a>
                        <a class="btn-solid btn-sm info-btns mt-4 mx-2" href="https://api.whatsapp.com/send?phone=919047473959&amp;text=Hi, I've queries about the product " diya="" hanging="" with="" venkat="" cocob05=""><i class="fa-brands fa-whatsapp"></i>WhatsApp</a>
                      </div>
                    </div>

                    <div className="mt-5">
                      <h5>Product Description</h5>
                      <div className="content-color mt-2" dangerouslySetInnerHTML={createDescription()} />
                      <div className="option rating-option">
                        <h5 className="heading mt-2">Size:<span className="bg-theme-blue"></span></h5><span>{(selectedSize != null) ? (<>{selectedSize.rawData.size}</>) : (<>{product.item_size}</>)}</span>
                      </div>
                      <div className="option rating-option mt-3">
                        <h5 className="heading mt-2">Weight: <span className="bg-theme-blue"></span></h5>
                        <span>{product.item_weight}g/Item</span>
                      </div>
                      <div className="content-color mt-2">
                        The dimension & weight calculated for shipping might
                        vary as per the packing requirement of the product.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Related Products */}

        <section class="pt-0 ratio_asos">
          <div class="container-lg">
            <div class="title-box4">
              <h4 class="heading font-2xl">YOU MAY ALSO LIKE… <span class="bg-theme-blue"></span></h4>
            </div>

            <Swiper slidesPerView={1.5} spaceBetween={15} breakpoints={{
              576: {
                slidesPerView: 1.5
              },
              768: {
                slidesPerView: 2.5
              },
              992: {
                slidesPerView: 4.5
              },
              1200: {
                slidesPerView: 5.5
              }
            }} modules={[Navigation]} className="related-products-swiper" >

              {relatedProduct?.map((relateproduct) => (
                <SwiperSlide key={relateproduct.p_id}>
                  <div className="product-box border-lg" style={{border: '1px solid #fff'}}>
                    <a href={`/singleproduct?id=${relateproduct.p_id}`} className="product-img">
                      <img className="img-fluid rounded-corners" src={`https://api.welbeing.in/uploads/products/${relateproduct.img1}`} alt={relateproduct.item_name}
                        style={{
                          width: '100%',
                          height: '250px',
                          objectFit: 'cover',
                          borderRadius: '20px'
                        }}
                        onError={(e) => {
                          e.target.src = "https://api.welbeing.in/uploads/products/no_img.jpg";
                        }}
                      />
                    </a>
                    <div className="product-content" style={{padding: '0px 10px'}}>
                      <a href={`/singleproduct?id=${relateproduct.p_id}`} className="product-title">
                        <h6 className="heading mt-2">{relateproduct.item_name?.length > 28 ? relateproduct.item_name.slice(0, 28) + "..." : relateproduct.item_name}</h6>
                      </a>
                      <div className="price mt-2 mb-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                        <del style={{ color: '#911077', paddingTop: '5px' }}>₹{(parseFloat(relateproduct.item_price) + Math.floor(Math.random() * 10) + 1).toFixed(2)}</del>
                        <span><b style={{fontSize: '20px'}}>₹{Number(relateproduct.item_price).toFixed(2)}</b></span> 
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}

            </Swiper>
          </div>
        </section>

      </main>
      <Footer />
    </>
  );
};

export default SingleProduct;
